import * as React from "react";
import { AppReportTaskTypeDocumentReference } from "ui/Scripts/source/models/appReportTemplate/appReportTaskTypeDocumentReference";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { Translations } from "ui/Scripts/source/models/translations";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { SectionIcon, SectionType } from "source/components/framework/Icon/SectionIcon";
import { TaskDynamicFormReferenceWarning } from "./TaskDynamicFormReferenceWarning";

export interface ITaskDynamicFormDocumentReferenceProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormDocumentReference = (props: ITaskDynamicFormDocumentReferenceProp) => {
    const documentReference = new AppReportTaskTypeDocumentReference(props.taskTypeCol.objectValue);

    return (
        <>
            <Divider sx={{
                "maxWidth": "100%",
                "overflow": "hidden",
                "&::before, &::after": {
                    borderColor: "#000"
                }
            }}>
                <Box sx={{ padding: "8px 0" }}>
                    <Tooltip title={documentReference.documentPath}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <SectionIcon sx={{ marginRight: "8px" }} type={SectionType.Documents} />
                            <span>{Translations.FormDocumentReference}: </span>
                            <Box component="span" marginLeft="5px">
                                {(documentReference.documentId
                                    ? documentReference.documentName
                                    : <Typography color="red">{"'" + Translations.NotSelected + "'"}</Typography>
                                )}
                            </Box>
                        </Box>
                    </Tooltip>
                </Box>
            </Divider>
            {!documentReference.documentId &&
                <TaskDynamicFormReferenceWarning
                    message={String.format(Translations.FormDocumentReferenceWarning, Translations.Document)}
                />
            }
        </>
    );
};